import { Select, type SelectProps } from 'antd';
import type { VFC } from 'react';
import type { DefaultOptionType } from 'antd/lib/select';
import { Locale, type StrictOmit } from '@enmon/commons';
import { filterOption, filterSort } from '../utils';

export interface LocaleSelectProps extends StrictOmit<SelectProps<number>, 'options'> {
  onChange?: (value: number | null) => void;
}

export const LocaleSelect: VFC<LocaleSelectProps> = ({ onChange, ...propsToPass }) => {
  return (
    <Select
      showSearch
      filterOption={filterOption}
      filterSort={filterSort}
      options={Object.values(Locale).map<DefaultOptionType>(locale => ({
        value: locale,
        label: locale,
      }))}
      onSelect={(id?: number) => onChange?.(id)}
      {...propsToPass}
    />
  );
};
